module.exports = __webpack_public_path__ + "img/bg.fa0b1d19.png";